var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isReady)?_c('ActionBar',{attrs:{"model":_vm.model,"show-titles":_vm.showTitles,"popover-position":_vm.popoverPosition,"popover-position-mobile":_vm.popoverPositionMobile,"buy-button":_vm.buyButton}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }